// import { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";

// const dummyData = {
//   "Location A": [
//     {
//       id: 1,
//       name: "Session 1",
//       present: 25,
//       absent: 5,
//       students: [
//         { id: "STU001", name: "Amit Kumar", status: "Present" },
//         { id: "STU002", name: "Riya Sharma", status: "Absent" },
//         { id: "STU003", name: "Rahul Verma", status: "Present" },
//       ],
//     },
//     {
//       id: 2,
//       name: "Session 2",
//       present: 28,
//       absent: 2,
//       students: [
//         { id: "STU004", name: "Sneha Patel", status: "Present" },
//         { id: "STU005", name: "Mohit Singh", status: "Present" },
//       ],
//     },
//     {
//       id: 3,
//       name: "Session 3",
//       present: 26,
//       absent: 4,
//       students: [
//         { id: "STU006", name: "Priya Das", status: "Absent" },
//         { id: "STU007", name: "Kunal Mehra", status: "Present" },
//       ],
//     },
//     {
//       id: 4,
//       name: "Session 4",
//       present: 27,
//       absent: 3,
//       students: [
//         { id: "STU008", name: "Vikram Joshi", status: "Present" },
//         { id: "STU009", name: "Nisha Yadav", status: "Absent" },
//       ],
//     },
//   ],
//   "Location B": [
//     {
//       id: 1,
//       name: "Session 1",
//       present: 30,
//       absent: 0,
//       students: [
//         { id: "STU010", name: "Arjun Gupta", status: "Present" },
//         { id: "STU011", name: "Sita Rai", status: "Present" },
//       ],
//     },
//   ],
// };

// export default function StudentRecordDetails() {
//   const [selectedLocation, setSelectedLocation] = useState("Location A");
//   const [expandedSession, setExpandedSession] = useState(null);

//   const sessions = dummyData[selectedLocation] || [];

//   return (
//     <div className="p-8 min-h-screen bg-gray-50" style={{padding:'20px'}}>
//       <h1 className="text-2xl font-bold text-gray-800 mb-6">
//         📍 Attendance Dashboard
//       </h1>

//       {/* Location Selector */}
//       <div  style={{marginBottom:'20px',marginTop:'20px'}}>
//         <select
//          style={{color:'#000',width:'250px',borderRadius:'6px',height:'50px'}}
//           value={selectedLocation}
//           onChange={(e) => setSelectedLocation(e.target.value)}
//           className="px-4 py-2 rounded-md border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//         >
//           {Object.keys(dummyData).map((loc) => (
//             <option key={loc} value={loc}>
//               {loc}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Session Cards */}
//       <div >
//         {sessions.map((session) => (
//           <div
//             key={session.id}
//             className="bg-white rounded-xl shadow hover:shadow-lg transition border border-gray-100"
//           >
//             <div
//             style={{color:'#000'}}
//               className="flex items-center justify-between px-4 py-3 cursor-pointer"
//               onClick={() =>
//                 setExpandedSession(
//                   expandedSession === session.id ? null : session.id
//                 )
//               }
//             >
//               <h2  style={{color:'#000'}} className="text-lg font-semibold text-gray-700">
//                 {session.name}
//               </h2>
//               {expandedSession === session.id ? (
//                 <ChevronUp className="w-5 h-5 text-gray-500" />
//               ) : (
//                 <ChevronDown className="w-5 h-5 text-gray-500" />
//               )}
//             </div>

//             <div className="px-4 pb-4" style={{color:'#000'}}>
//               {/* Present/Absent Counts */}
//               <div className="flex gap-6 mb-2">
//                 <span className="text-green-600 font-bold">
//                   ✅ Present: {session.present}
//                 </span>
//                 <span className="text-red-600 font-bold">
//                   ❌ Absent: {session.absent}
//                 </span>
//               </div>

//               {/* Expanded Student List */}
//               {expandedSession === session.id && (
//                 <div className="mt-3 space-y-2"  style={{color:'#000'}}>
//                   {session.students.map((student) => (
//                     <div
//                       key={student.id}
//                       className="flex justify-between items-center p-2 border rounded-md bg-gray-50"
//                     >
//                       <span  style={{color:'#000'}} className="font-medium text-gray-700">
//                         {student.name} ({student.id})
//                       </span>
//                       <span  style={{color:'#000'}}
//                         className={`text-sm font-semibold ${
//                           student.status === "Present"
//                             ? "text-green-600"
//                             : "text-red-600"
//                         }`}
//                       >
//                         {student.status}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }



// import { useMemo, useState } from "react";
// import {
//   BarChart,
//   Bar,
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   Legend,
// } from "recharts";
// import { CalendarDays, MapPin, Users, UserMinus, Clock, TrendingUp } from "lucide-react";
// // import "./AttendanceDashboard.css";  // ✅ External CSS file
// import './AttendanceDashboardRe.css'
// const demoData = { /* same data as your code */ };

// const COLORS = {
//   green: "#10b981",
//   red: "#ef4444",
//   amber: "#f59e0b",
//   blue: "#3b82f6",
//   cyan: "#06b6d4",
//   purple: "#8b5cf6",
//   gray500: "#6b7280",
// };

// const toPct = (num, denom) => Math.round((num / Math.max(denom, 1)) * 1000) / 10;

// export default function AttendanceDashboard() {
//   const [location, setLocation] = useState("Main Campus");
//   const [range, setRange] = useState("7D");

//   const data = demoData[location];

//   const totals = useMemo(() => {
//     const totalPresent = data.sessions.reduce((s, x) => s + x.present, 0);
//     const totalAbsent = data.sessions.reduce((s, x) => s + x.absent, 0);
//     const totalLate = data.sessions.reduce((s, x) => s + (x.late || 0), 0);
//     const latest = data.sessions[data.sessions.length - 1];
//     const todayPct = toPct(latest.present, data.totalStudents);
//     const avgPct = Math.round(
//       (data.sessions.reduce((s, x) => s + toPct(x.present, data.totalStudents), 0) / data.sessions.length) * 10
//     ) / 10;
//     return { totalPresent, totalAbsent, totalLate, todayPct, avgPct };
//   }, [data]);

//   const trendData = useMemo(
//     () =>
//       data.sessions.map((s) => ({
//         date: s.date.slice(5),
//         Present: toPct(s.present, data.totalStudents),
//         Absent: toPct(s.absent, data.totalStudents),
//         Late: toPct(s.late || 0, data.totalStudents),
//       })),
//     [data]
//   );

//   const donutData = [
//     { name: "Present", value: totals.totalPresent, color: COLORS.green },
//     { name: "Absent", value: totals.totalAbsent, color: COLORS.red },
//     { name: "Late", value: totals.totalLate, color: COLORS.amber },
//   ];

//   const entryExit = data.entryExit;

//   return (
//     <div className="dashboard-container">
//       {/* Header */}
//       <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
//         <div>
//           <h1 className="dashboard-title">Attendance Overview</h1>
//           <p className="dashboard-subtitle">Live view across locations, sessions, and gates</p>
//         </div>
//         <div className="d-flex align-items-center gap-3">
//           <div className="location-selector">
//             <MapPin className="icon" />
//             <select value={location} onChange={(e) => setLocation(e.target.value)} className="form-select">
//               {Object.keys(demoData).map((loc) => (
//                 <option key={loc} value={loc}>{loc}</option>
//               ))}
//             </select>
//           </div>
//           <div className="range-buttons">
//             <button className={`btn ${range === "Today" ? "btn-dark" : "btn-light"}`} onClick={() => setRange("Today")}>Today</button>
//             <button className={`btn ${range === "7D" ? "btn-dark" : "btn-light"}`} onClick={() => setRange("7D")}>7D</button>
//             <button className={`btn ${range === "30D" ? "btn-dark" : "btn-light"}`} onClick={() => setRange("30D")}>30D</button>
//             <CalendarDays className="calendar-icon" />
//           </div>
//         </div>
//       </div>

//       {/* KPI Cards */}
//       <div className="row g-4">
//         <div className="col-md-3">
//           <div className="card kpi-card">
//             <div className="card-body">
//               <h6 className="kpi-title">Attendance Today</h6>
//               <TrendingUp className="icon-green" />
//               <h3 className="kpi-value">{totals.todayPct}%</h3>
//               <p className="kpi-subtitle">Avg: {totals.avgPct}% last {data.sessions.length} sessions</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-3">
//           <div className="card kpi-card">
//             <div className="card-body">
//               <h6 className="kpi-title">Total Present</h6>
//               <Users className="icon-green" />
//               <h3 className="kpi-value text-success">{totals.totalPresent}</h3>
//               <p className="kpi-subtitle">Across {data.sessions.length} sessions</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-3">
//           <div className="card kpi-card">
//             <div className="card-body">
//               <h6 className="kpi-title">Total Absent</h6>
//               <UserMinus className="icon-red" />
//               <h3 className="kpi-value text-danger">{totals.totalAbsent}</h3>
//               <p className="kpi-subtitle">Across {data.sessions.length} sessions</p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-3">
//           <div className="card kpi-card">
//             <div className="card-body">
//               <h6 className="kpi-title">Late Arrivals</h6>
//               <Clock className="icon-amber" />
//               <h3 className="kpi-value text-warning">{totals.totalLate}</h3>
//               <p className="kpi-subtitle">Flagged at gates</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Charts & Table remain same */}
//       {/* I kept Recharts code same — only styling moved to CSS */}
//     </div>
//   );
// }
import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { Users, UserMinus } from "lucide-react";
import "./AttendanceDashboardRe.css"; // ✅ External CSS file


// Dummy data
const dummyData = {
  "Main Campus": {
    totalStudents: 950,
    sessions: [
      {
        id: 101,
        date: "2025-08-26",
        name: "Session 1",
        present: 860,
        absent: 90,
        students: [
          { id: "STU001", name: "Amit Kumar", status: "Present" },
          { id: "STU002", name: "Riya Sharma", status: "Absent" },
        ],
      },
      {
        id: 102,
        date: "2025-08-27",
        name: "Session 2",
        present: 872,
        absent: 78,
        students: [
          { id: "STU003", name: "Rahul Verma", status: "Present" },
          { id: "STU004", name: "Sneha Patel", status: "Present" },
        ],
      },
    ],
  },
  "Annex Campus": {
    totalStudents: 480,
    sessions: [
      {
        id: 201,
        date: "2025-08-26",
        name: "Session 1",
        present: 420,
        absent: 60,
        students: [
          { id: "STU005", name: "Kunal Mehra", status: "Present" },
          { id: "STU006", name: "Nisha Yadav", status: "Absent" },
        ],
      },
    ],
  },
};



export default function AttendanceDashboard() {
  const history = useHistory()

  const [selectedLocation, setSelectedLocation] = useState("Main Campus");
// const [expandedSession, setExpandedSession] = useState<number | null>(null);
const [expandedSession, setExpandedSession] = useState(null);

  const [showSessionReport, setShowSessionReport] = useState(false);

  const sessions = dummyData[selectedLocation]?.sessions || [];


 const handelClickTR =()=>{
   
    history.push("dashboard")

  }


  return(
    <div>
      {/* Header */}
      <div className="dashboard-headerq">
        <div style={{
              paddingLeft: "1%",
    paddingRight: "1%",
    fontSize: "20px",
    fontWeight: "bold",
    borderColor: "black",
    
        }}>Attendance Dashboard</div>
        <div className="tab-buttons">
          <button
            className={`tab-btn ${!showSessionReport ? "active" : ""}`}
            onClick={() => handelClickTR(false)} style={{    width: "140px",
    height: '48px'}}
          >
            Overall View
          </button>
          <button
            className={`tab-btn ${showSessionReport ? "active" : ""}`}
            onClick={() => setShowSessionReport(true)} style={{width: "auto",
    height: "auto"}}
          >
            Per Session Report
          </button>
      
        </div>
      </div>

      {/* Location Dropdown */}
      <div style={{ marginBottom: "20px",
              paddingLeft: "1%",
    paddingRight: "1%",
    fontSize: "20px",
    fontWeight: "bold",
    borderColor: "black", }}>
        <label style={{ marginRight: "10px" , border: "none",
    fontSize: "22px"}}>Location</label>
        <select
          className="location-select"
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
        >
          {Object.keys(dummyData).map((loc) => (
            <option key={loc} value={loc}>
              {loc}
            </option>
          ))}
        </select>
      </div>

      {/* Overall View */}
      {!showSessionReport && (
        <div style={{
              paddingLeft: "1%",
    paddingRight: "1%",
    fontSize: "20px",
    fontWeight: "bold",
    borderColor: "black",
    display:'flex',
    justifyContent:'center',color:'red'}} >
          Overall graphs/charts will be displayed here.
        </div>
      )}

      {/* Per Session Report */}
      {showSessionReport && (
        <div style={{
              paddingLeft: "1%",
    paddingRight: "1%",
    fontSize: "20px",
    fontWeight: "bold",
    borderColor: "black",}} className="session-grid">
          {sessions.map((session) => (
            <div key={session.id} className="session-card">
              <div className="session-header">
                <h2 style={{color: "white"}}>{session.name}</h2>
                <button
                  className="toggle-btn"
                  onClick={() =>
                    setExpandedSession(
                      expandedSession === session.id ? null : session.id
                    )
                  }
                >
                  {expandedSession === session.id ? (
                    <ChevronUp size={18} />
                  ) : (
                    <ChevronDown size={18} />
                  )}
                </button>
              </div>

              <div className="session-details">
                <div className="pills">
                  <span className="pill present">Present: {session.present}</span>
                  <span className="pill absent">Absent: {session.absent}</span>
                </div>

                <div className="session-info">
                  <div>
                    <p>
                      <span>Session ID:</span> {session.id}
                    </p>
                    <p>
                      <span>Date:</span> {session.date}
                    </p>
                  </div>
                  <button
                    className="view-btn"
                    onClick={() => setExpandedSession(session.id)}
                  >
                    View Students
                  </button>
                </div>

                {expandedSession === session.id && session.students && (
                  <div className="students-list">
                    {session.students.map((student) => (
                      <div key={student.id} className="student-card">
                        <span>
                          {student.name} ({student.id})
                        </span>
                        <span
                          className={`student-status ${
                            student.status === "Present" ? "present" : "absent"
                          }`}
                        >
                          {student.status}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
